import React from "react";

const CMYKFull = ({ width = 200, height = 400 }) => {
  const barWidth = width / 4; // Each column takes 1/4 of the total width
  const rectHeight = height / 10; // Height for each opacity block
  const colors = ["#00FFFF", "#FF00FF", "#FFFF00", "#000000"]; // CMYK colors

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {colors.map((color, columnIndex) =>
        Array.from({ length: 10 }).map((_, i) => (
          <rect
            key={`${color}-${i}`}
            x={barWidth * columnIndex} // Position the column
            y={rectHeight * i} // Position each rectangle vertically
            width={barWidth} // Full column width
            height={rectHeight} // Equal height for each block
            fill={color}
            opacity={(10 - i) / 10} // Start at 1.0 opacity, decrease by 0.1
          />
        ))
      )}
    </svg>
  );
};

export default CMYKFull;
